// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentHeader_root__DVK2n"};